/* @refresh reload */
import "./global.css"

import "@fontsource-variable/lora/wght.css"
import "@fontsource-variable/lora/wght-italic.css"
import "@fontsource-variable/geist-mono"
import "@fontsource-variable/geist"

import "@repo/fika-blog/src/content.css"
import "katex/dist/katex.min.css"
import "overlayscrollbars/overlayscrollbars.css"

import { isValidUrl } from "@repo/fika-shared/src/lib/slug.js"
import { Route, Router } from "@solidjs/router"
import { render } from "solid-js/web"
import { ApplicationLayout } from "@/designSystem/layouts/application-layout"
import { RootLayout } from "@/designSystem/layouts/root-layout"
import { Subscribe } from "./pages/auth/subscribe"
import { Dashboard } from "./pages/dashboard/dashboard-page"
import { InboxList } from "./pages/inbox/inbox-list"
import { ThreadView } from "./pages/inbox/thread-view"
import { ReaderOnboardingPage } from "./pages/onboarding/reader-onboarding-page"
import { WriterOnboarding } from "./pages/onboarding/writer-onboarding"
import { PostAudience } from "./pages/posts/post-audience"
import { PostItem } from "./pages/posts/post-item"
import { PostList, preloadPostList } from "./pages/posts/post-list"
import { PostNotes } from "./pages/posts/post-notes"
import { PostPublish } from "./pages/posts/post-publish"
import { PostPublishShare } from "./pages/posts/post-publish-share"
import { PostSettings } from "./pages/posts/post-settings"
import { PostTranslations } from "./pages/posts/post-translations"
import { PostVersions } from "./pages/posts/post-versions"
import PublicationSubscribers, {
  preloadPublicationSubscribers,
} from "./pages/posts/publication-subscribers"
import { PostsSettings } from "./pages/posts/settings"
import { Stats } from "./pages/posts/stats"
import { preloadSettings, Settings } from "./pages/settings/page"
import { SubscriptionItem } from "./pages/subscriptions/subscription-item"
import { SubscriptionItemManage } from "./pages/subscriptions/subscription-item-manage"
import { SubscriptionList } from "./pages/subscriptions/subscription-list"
import { SubscriptionManage } from "./pages/subscriptions/subscription-manage"
import { Unsubscribe } from "./pages/unsubscribe"

// Sentry and Posthog
import "./lib/observability"
import { PostProofReader } from "./pages/posts/post-proofread"
import { PostShare } from "./pages/posts/post-share"
import { PublicationForms } from "./pages/posts/publication-forms"

const root = document.getElementById("root")

function NotFound() {
  return <div>not found</div>
}

const slugFilters = {
  storyId: isValidUrl,
  postId: isValidUrl,
  publisherId: isValidUrl,
  ideaId: isValidUrl,
}

render(
  () => (
    <Router root={RootLayout}>
      <Route path="/subscribe" component={Subscribe} />
      <Route path="/unsubscribe" component={Unsubscribe} />
      <Route path="/" component={ApplicationLayout}>
        <Route path="/writer-onboarding" component={WriterOnboarding} />
        <Route path="/reader-onboarding" component={ReaderOnboardingPage} />
        <Route path="/" component={Dashboard} />

        <Route path="/subscriptions/:listParams?">
          <Route path="/" component={SubscriptionList} />
          <Route path="/manage/:manageParams?">
            <Route path="/" component={SubscriptionManage} />
            <Route
              path="/subscription/:subscriptionId"
              component={SubscriptionItemManage}
            />
          </Route>
          <Route
            path="/:postId"
            component={SubscriptionItem}
            matchFilters={slugFilters}
          />
        </Route>

        <Route path="/blog/:listParams?">
          <Route path="/" component={PostList} preload={preloadPostList} />
          <Route
            path="/audience/:subscriberListParams?"
            component={PublicationSubscribers}
            preload={preloadPublicationSubscribers}
          />
          <Route path="/settings" component={PostsSettings} />
          <Route path="/forms/:formId?" component={PublicationForms} />
          <Route path="/stats/:statsParams?" component={Stats} />
          <Route path="/post/:postId" matchFilters={slugFilters}>
            <Route path="/publish" component={PostPublish} />
            <Route path="/publish/share" component={PostPublishShare} />
            <Route path="/update" component={PostPublish} />
            <Route path="/versions/:versionId?" component={PostVersions} />
            <Route path="/" component={PostItem}>
              <Route path="/settings" component={PostSettings} />
              <Route path="/audience" component={PostAudience} />
              <Route path="/notes" component={PostNotes} />
              <Route path="/translations" component={PostTranslations} />
              <Route path="/proofread" component={PostProofReader} />
              <Route path="/share" component={PostShare} />
              <Route path="/" />
            </Route>
          </Route>
        </Route>

        <Route path="/inbox">
          <Route path="/" component={InboxList} />
          <Route path="/:threadId" component={ThreadView} />
        </Route>

        <Route path="/settings">
          <Route path="/" component={Settings} preload={preloadSettings} />
        </Route>
        <Route path="*404" component={NotFound} />
      </Route>
    </Router>
  ),
  root!,
)
